import * as React from "react";
import {
  List,
  DataTable,
  TextField,
  ReferenceField,
  ReferenceArrayField,
  SingleFieldList,
  ChipField,
  EditButton,
  ReferenceInput,
  AutocompleteInput,
  ReferenceArrayInput,
  AutocompleteArrayInput,
  BooleanInput,
  DateField,
} from "react-admin";
import { RESTAURANT_TYPES } from "../enums/RestaurantTypes";

const RestaurantMercadoPagoTokenFilter = () => [
  <ReferenceInput
    source="restaurant"
    reference="restaurants"
    perPage={100}
    filter={{
      type: RESTAURANT_TYPES.REGULAR,
      active: true,
      linkedToMercadoPago: true,
    }}
    label="Restaurante"
    alwaysOn
  >
    <AutocompleteInput
      filterToQuery={(searchText) => ({ name: searchText })}
      label="Restaurante"
      optionText="name"
    />
  </ReferenceInput>,
  <ReferenceArrayInput
    source="restaurants"
    reference="restaurants"
    perPage={100}
    filter={{
      type: RESTAURANT_TYPES.REGULAR,
      active: true,
    }}
    label="Restaurantes Asociados"
  >
    <AutocompleteArrayInput
      filterToQuery={(searchText) => ({ name: searchText })}
      label="Restaurantes Asociados"
      fullWidth
      optionText="name"
    />
  </ReferenceArrayInput>,
  <BooleanInput alwaysOn={true} label="Activo" source="active" />,
];

const RestaurantMercadoPagoTokenList = () => (
  <List
    title="Mercado Pago"
    filters={RestaurantMercadoPagoTokenFilter()}
    exporter={false}
    filterDefaultValues={{
      active: true,
    }}
  >
    <DataTable rowClick="show" bulkActionButtons={false}>
      <DataTable.Col source="restaurant" label="Restaurante">
        <ReferenceField
          label="Restaurante"
          reference="restaurants"
          source="restaurant"
          link={false}
        >
          <TextField source="name" label="Nombre" />
        </ReferenceField>
      </DataTable.Col>
      <DataTable.Col source="restaurants" label="Restaurantes Asociados">
        <ReferenceArrayField
          label="Restaurantes Asociados"
          reference="restaurants"
          source="restaurants"
        >
          <SingleFieldList linkType={false}>
            <ChipField source="name" size="small" />
          </SingleFieldList>
        </ReferenceArrayField>
      </DataTable.Col>
      <DataTable.Col source="updatedAt" label="Fecha de Actualización">
        <DateField
          source="updatedAt"
          label="Fecha de Actualización"
          showTime={true}
        />
      </DataTable.Col>
      <DataTable.Col source="tokenExpirationDate" label="Fecha de Expiración">
        <DateField
          source="tokenExpirationDate"
          label="Fecha de Expiración"
          showTime={true}
        />
      </DataTable.Col>
      <DataTable.Col>
        <EditButton />
      </DataTable.Col>
    </DataTable>
  </List>
);

export default RestaurantMercadoPagoTokenList;
